export default {
  // Listado
  incidencias: null,       // { data: [], total: 0, per_page: 20, current_page: 1 }
  kpis: null,              // { incidencias_activas, incidencias_criticas, clientes_afectados, ... }
  arbolServicios: null,    // árbol jerárquico de categorías/servicios

  // Detalle
  incidenciaDetalle: null, // incidencia completa con relaciones + sla
  ticketsAsociados: null,  // { data: [], total: 0 }
  seguimientos: null,      // { data: [], total: 0 }
  comunicaciones: null,    // { data: [], total: 0 }
  historialAuditoria: null,// { data: [], total: 0 }
  plantillas: [],          // plantillas de comunicación activas
  usuariosResponsables: [],// lista de usuarios para selector

  // UI
  loading: false,
  loadingDetalle: false,
  vista: 'lista',          // 'lista' | 'kanban'
  filtros: {
    search: '',
    estado: null,
    nivel_impacto: null,
    comunicacion: null,
    responsable: null,
  },
}
